<nz-spin
  [nzSpinning]="pageLoading || assetDeleteLoading"
  [nzTip]="(assetDeleteLoading ? 'robot-service.config.delete-loading' : 'common.loading') | i18n"
  nzSize="large"
  testId="robot-config-page-spin"
>
  <div class="robot-config-shell" [class.embedded-mode]="embeddedInDrawer" testId="robot-config-shell">
    <div class="content-wrapper" testId="robot-config-content-wrapper">
      <div class="robot-config-page">
        <div class="robot-config-container" [testId]="'robot-config-container'">
          <div class="config-header" testId="robot-config-header">
            <div class="left-actions" testId="robot-config-left-actions">
              <button
                *ngIf="!embeddedInDrawer"
                nz-button
                nzType="link"
                class="back-btn"
                (click)="close()"
                testId="robot-config-back-button"
              >
                <i nz-icon nzType="arrow-left"></i>
                <span>{{ 'common.back' | i18n }}</span>
              </button>
              <h3 class="title" testId="robot-config-title">{{ 'robot-service.config.title' | i18n }}</h3>
            </div>
            <div class="actions" testId="robot-config-actions">
              <button
                nz-button
                nzType="primary"
                type="button"
                class="test-answer-btn"
                (click)="openRobotAnswerTest()"
                [disabled]="!robotId || !serviceNumberId"
                testId="robot-config-test-answer-button"
              >
                <i nz-icon nzType="message"></i>
                {{ 'servicenumber.robot.test.trigger' | i18n }}
              </button>
              <button nz-button (click)="reload()" [disabled]="reloadDisabled" testId="robot-config-refresh-button">{{
                'common.refresh' | i18n
              }}</button>
            </div>
          </div>
        </div>

        <div class="section-card" *ngIf="showRole" testId="robot-config-role-section">
          <div class="section-header">
            <div>
              <h4 class="section-title" testId="robot-config-role-title">{{ 'robot-service.config.role-section.title' | i18n }}</h4>
              <div class="section-desc">{{ 'robot-service.config.role-section.desc' | i18n }}</div>
            </div>
            <button
              nz-button
              nzType="primary"
              type="button"
              class="role-save-btn"
              (click)="submitRoleSettings()"
              [nzLoading]="roleSaving"
              [disabled]="!robotId || !serviceNumberId || roleSaving || !configForm.dirty"
              testId="robot-config-role-save-button"
            >
              {{ 'robot-service.config.role.save-button' | i18n }}
            </button>
          </div>

          <form nz-form nzLayout="vertical" [formGroup]="configForm" class="config-form" testId="robot-config-role-form">
            <div class="role-group">
              <h5 class="section-title" testId="robot-config-role-basic-title">{{ 'robot-service.config.role.group.basic' | i18n }}</h5>
              <div class="section-desc">{{ 'robot-service.config.role.group.basic-desc' | i18n }}</div>
              <div nz-row [nzGutter]="16">
                <div nz-col [nzSpan]="12">
                  <nz-form-item>
                    <nz-form-label>
                      <span>{{ 'robot-service.config.role.persona' | i18n }}</span>
                      <span
                        class="field-help-icon"
                        nz-tooltip
                        nzTooltipTrigger="click"
                        nzTooltipPlacement="topLeft"
                        nzTooltipOverlayClassName="robot-role-field-tip"
                        [nzTooltipTitle]="'robot-service.config.role.persona.tip' | i18n"
                        testId="robot-config-persona-tip"
                        >?</span
                      >
                    </nz-form-label>
                    <nz-form-control>
                      <nz-select
                        formControlName="persona"
                        [nzPlaceHolder]="'robot-service.config.role.persona.placeholder' | i18n"
                        testId="robot-config-persona-select"
                      >
                        <nz-option nzValue="assistant" [nzLabel]="'robot-service.config.role.persona.assistant' | i18n" />
                        <nz-option nzValue="sales" [nzLabel]="'robot-service.config.role.persona.sales' | i18n" />
                        <nz-option nzValue="support" [nzLabel]="'robot-service.config.role.persona.support' | i18n" />
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                  <nz-form-item>
                    <nz-form-label>
                      <span>{{ 'robot-service.config.role.tone' | i18n }}</span>
                      <span
                        class="field-help-icon"
                        nz-tooltip
                        nzTooltipTrigger="click"
                        nzTooltipPlacement="topLeft"
                        nzTooltipOverlayClassName="robot-role-field-tip"
                        [nzTooltipTitle]="'robot-service.config.role.tone.tip' | i18n"
                        testId="robot-config-tone-tip"
                        >?</span
                      >
                    </nz-form-label>
                    <nz-form-control>
                      <nz-select formControlName="tone" testId="robot-config-tone-select">
                        <nz-option nzValue="friendly" [nzLabel]="'robot-service.config.role.tone.friendly' | i18n" />
                        <nz-option nzValue="formal" [nzLabel]="'robot-service.config.role.tone.formal' | i18n" />
                        <nz-option nzValue="neutral" [nzLabel]="'robot-service.config.role.tone.neutral' | i18n" />
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                  <nz-form-item>
                    <nz-form-label>
                      <span>{{ 'robot-service.config.role.background' | i18n }}</span>
                      <span
                        class="field-help-icon"
                        nz-tooltip
                        nzTooltipTrigger="click"
                        nzTooltipPlacement="topLeft"
                        nzTooltipOverlayClassName="robot-role-field-tip"
                        [nzTooltipTitle]="'robot-service.config.role.background.tip' | i18n"
                        testId="robot-config-background-tip"
                        >?</span
                      >
                    </nz-form-label>
                    <nz-form-control>
                      <nz-select
                        formControlName="background"
                        [nzPlaceHolder]="'robot-service.config.role.background.placeholder' | i18n"
                        testId="robot-config-background-select"
                      >
                        <nz-option nzValue="none" [nzLabel]="'robot-service.config.role.background.none' | i18n" />
                        <nz-option nzValue="company" [nzLabel]="'robot-service.config.role.background.company' | i18n" />
                        <nz-option nzValue="product" [nzLabel]="'robot-service.config.role.background.product' | i18n" />
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                  <nz-form-item>
                    <nz-form-label>
                      <span>{{ 'robot-service.config.role.content-size' | i18n }}</span>
                      <span
                        class="field-help-icon"
                        nz-tooltip
                        nzTooltipTrigger="click"
                        nzTooltipPlacement="topLeft"
                        nzTooltipOverlayClassName="robot-role-field-tip"
                        [nzTooltipTitle]="'robot-service.config.role.content-size.tip' | i18n"
                        testId="robot-config-content-size-tip"
                        >?</span
                      >
                    </nz-form-label>
                    <nz-form-control>
                      <nz-select formControlName="contentSize" testId="robot-config-content-size-select">
                        <nz-option nzValue="short" [nzLabel]="'robot-service.config.role.content-size.short' | i18n" />
                        <nz-option nzValue="medium" [nzLabel]="'robot-service.config.role.content-size.medium' | i18n" />
                        <nz-option nzValue="long" [nzLabel]="'robot-service.config.role.content-size.long' | i18n" />
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>

            <div class="role-group">
              <h5 class="section-title" testId="robot-config-role-replies-title">{{ 'robot-service.config.role.group.replies' | i18n }}</h5>
              <div class="section-desc">{{ 'robot-service.config.role.group.replies-desc' | i18n }}</div>
              <div nz-row [nzGutter]="16">
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label>
                      <span>{{ 'robot-service.config.role.welcome-message' | i18n }}</span>
                      <span
                        class="field-help-icon"
                        nz-tooltip
                        nzTooltipTrigger="click"
                        nzTooltipPlacement="topLeft"
                        nzTooltipOverlayClassName="robot-role-field-tip"
                        [nzTooltipTitle]="'robot-service.config.role.welcome-message.tip' | i18n"
                        testId="robot-config-welcome-message-tip"
                        >?</span
                      >
                    </nz-form-label>
                    <nz-form-control>
                      <textarea
                        nz-input
                        rows="3"
                        formControlName="welcomeMessage"
                        [placeholder]="'robot-service.config.role.welcome-message.placeholder' | i18n"
                        testId="robot-config-welcome-message-input"
                      ></textarea>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label>
                      <span>{{ 'robot-service.config.role.thanks-message' | i18n }}</span>
                      <span
                        class="field-help-icon"
                        nz-tooltip
                        nzTooltipTrigger="click"
                        nzTooltipPlacement="topLeft"
                        nzTooltipOverlayClassName="robot-role-field-tip"
                        [nzTooltipTitle]="'robot-service.config.role.thanks-message.tip' | i18n"
                        testId="robot-config-thanks-message-tip"
                        >?</span
                      >
                    </nz-form-label>
                    <nz-form-control>
                      <textarea
                        nz-input
                        rows="3"
                        formControlName="thanksMessage"
                        [placeholder]="'robot-service.config.role.thanks-message.placeholder' | i18n"
                        testId="robot-config-thanks-message-input"
                      ></textarea>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="24">
                  <nz-form-item>
                    <nz-form-label>
                      <span>{{ 'robot-service.config.role.no-answer-message' | i18n }}</span>
                      <span
                        class="field-help-icon"
                        nz-tooltip
                        nzTooltipTrigger="click"
                        nzTooltipPlacement="topLeft"
                        nzTooltipOverlayClassName="robot-role-field-tip"
                        [nzTooltipTitle]="'robot-service.config.role.no-answer-message.tip' | i18n"
                        testId="robot-config-no-answer-message-tip"
                        >?</span
                      >
                    </nz-form-label>
                    <nz-form-control>
                      <textarea
                        nz-input
                        rows="3"
                        formControlName="noAnswerMessage"
                        [placeholder]="'robot-service.config.role.no-answer-message.placeholder' | i18n"
                        testId="robot-config-no-answer-message-input"
                      ></textarea>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>

            <div class="role-group">
              <h5 class="section-title" testId="robot-config-role-naming-title">{{ 'robot-service.config.role.group.naming' | i18n }}</h5>
              <div class="section-desc">{{ 'robot-service.config.role.group.naming-desc' | i18n }}</div>
              <div nz-row [nzGutter]="16">
                <div nz-col [nzSpan]="8">
                  <nz-form-item>
                    <nz-form-label>
                      <span>{{ 'robot-service.config.role.user-title' | i18n }}</span>
                      <span
                        class="field-help-icon"
                        nz-tooltip
                        nzTooltipTrigger="click"
                        nzTooltipPlacement="topLeft"
                        nzTooltipOverlayClassName="robot-role-field-tip"
                        [nzTooltipTitle]="'robot-service.config.role.user-title.tip' | i18n"
                        testId="robot-config-user-title-tip"
                        >?</span
                      >
                    </nz-form-label>
                    <nz-form-control>
                      <input
                        nz-input
                        formControlName="userTitle"
                        [placeholder]="'robot-service.config.role.user-title.placeholder' | i18n"
                        testId="robot-config-user-title-input"
                      />
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="8">
                  <nz-form-item>
                    <nz-form-label>
                      <span>{{ 'robot-service.config.role.service-title' | i18n }}</span>
                      <span
                        class="field-help-icon"
                        nz-tooltip
                        nzTooltipTrigger="click"
                        nzTooltipPlacement="topLeft"
                        nzTooltipOverlayClassName="robot-role-field-tip"
                        [nzTooltipTitle]="'robot-service.config.role.service-title.tip' | i18n"
                        testId="robot-config-service-title-tip"
                        >?</span
                      >
                    </nz-form-label>
                    <nz-form-control>
                      <input
                        nz-input
                        formControlName="serviceTitle"
                        [placeholder]="'robot-service.config.role.service-title.placeholder' | i18n"
                        testId="robot-config-service-title-input"
                      />
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col [nzSpan]="8">
                  <nz-form-item>
                    <nz-form-label>
                      <span>{{ 'robot-service.config.role.answer-style' | i18n }}</span>
                      <span
                        class="field-help-icon"
                        nz-tooltip
                        nzTooltipTrigger="click"
                        nzTooltipPlacement="topLeft"
                        nzTooltipOverlayClassName="robot-role-field-tip"
                        [nzTooltipTitle]="'robot-service.config.role.answer-style.tip' | i18n"
                        testId="robot-config-answer-style-tip"
                        >?</span
                      >
                    </nz-form-label>
                    <nz-form-control>
                      <input
                        nz-input
                        formControlName="answerStyle"
                        [placeholder]="'robot-service.config.role.answer-style.placeholder' | i18n"
                        testId="robot-config-answer-style-input"
                      />
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="section-card knowledge-card" testId="robot-config-knowledge-section">
          <h4 class="section-title" testId="robot-config-knowledge-title">{{ 'robot-service.config.section.knowledge' | i18n }}</h4>
          <!-- 附件容量使用情況（僅計算文件與文本） -->
          <div class="usage-summary" testId="robot-config-usage-summary">
            <div class="usage-header">
              <span class="usage-title">{{ 'robot-service.config.usage.attachments' | i18n }}</span>
              <span class="usage-value">{{ knowledgeUsageFormat(knowledgeUsagePercent) }}</span>
            </div>
            <nz-progress [nzPercent]="knowledgeUsagePercent" nzStatus="active" [nzShowInfo]="false" testId="robot-config-usage-progress" />
          </div>
          <nz-tabset class="knowledge-tabset" testId="robot-config-knowledge-tabs">
            <!-- 自訂標籤：為每個 Tab 加上圖示 -->
            <ng-template #filesTabTitle>
              <span class="tab-title">
                <i nz-icon nzType="file" style="margin-right: 6px"></i>{{ 'robot-service.config.tab.files' | i18n }}
              </span>
            </ng-template>
            <ng-template #websitesTabTitle>
              <span class="tab-title">
                <i nz-icon nzType="global" style="margin-right: 6px"></i>{{ 'robot-service.config.tab.websites' | i18n }}
              </span>
            </ng-template>
            <ng-template #youtubeTabTitle>
              <span class="tab-title">
                <i nz-icon nzType="video-camera" style="margin-right: 6px"></i>{{ 'robot-service.config.tab.youtube' | i18n }}
              </span>
            </ng-template>
            <ng-template #textsTabTitle>
              <span class="tab-title">
                <i nz-icon nzType="file-text" style="margin-right: 6px"></i>{{ 'robot-service.config.tab.texts' | i18n }}
              </span>
            </ng-template>
            <nz-tab [nzTitle]="filesTabTitle" testId="robot-config-files-tab">
              <div class="files-tab-pane" testId="robot-config-files-pane">
                <div class="upload-area" testId="robot-config-file-upload-area">
                  <nz-upload
                    nzType="drag"
                    [nzMultiple]="true"
                    [nzShowUploadList]="false"
                    [nzCustomRequest]="customUploadReq"
                    [nzDisabled]="uploadDisabled"
                    testId="robot-config-file-upload"
                  >
                    <p class="ant-upload-drag-icon">
                      <i nz-icon nzType="inbox"></i>
                    </p>
                    <p class="ant-upload-text">{{ 'robot-service.config.upload.drag-text' | i18n }}</p>
                    <p class="ant-upload-hint">{{ 'robot-service.config.upload.hint' | i18n }}</p>
                    <p class="ant-upload-hint">{{ 'robot-service.config.upload.file-size-hint' | i18n }}</p>
                  </nz-upload>
                </div>

                <!-- 已上傳文件列表 -->
                <div class="uploaded-list" *ngIf="uploadedFiles.length > 0" testId="robot-config-uploaded-file-list">
                  <div class="file-item" *ngFor="let f of uploadedFiles; let i = index" [testId]="'robot-config-file-item-' + i">
                    <i nz-icon nzType="folder" class="file-icon"></i>
                    <span class="file-name">{{ f.name }}</span>
                    <span class="file-size">{{ formatFileSize(f.size) }}</span>
                    <nz-progress
                      class="file-progress"
                      *ngIf="shouldShowFileItemProgress(f)"
                      [nzPercent]="getFileItemProgressPercent(f)"
                      [nzShowInfo]="shouldShowFileItemPercent(f)"
                      [nzStatus]="getFileItemProgressStatus(f)"
                      [testId]="'robot-config-file-progress-' + i"
                    />
                    <button
                      *ngIf="shouldShowFileDownloadButton(f)"
                      nz-button
                      nzType="link"
                      (click)="downloadFile(f)"
                      [disabled]="assetDeleteLoading"
                      [attr.aria-label]="'common.download' | i18n"
                      [testId]="'robot-config-file-download-button-' + i"
                    >
                      <i nz-icon nzType="download"></i>
                    </button>
                    <button
                      nz-button
                      nzType="link"
                      class="delete-btn"
                      (click)="deleteFile(f, i)"
                      [disabled]="assetDeleteLoading"
                      [attr.aria-label]="'common.delete' | i18n"
                      [testId]="'robot-config-file-delete-button-' + i"
                    >
                      <i nz-icon nzType="delete"></i>
                    </button>
                  </div>
                </div>
              </div>
            </nz-tab>
            <nz-tab [nzTitle]="websitesTabTitle" testId="robot-config-websites-tab">
              <div class="assets-editor" testId="robot-config-websites-pane">
                <!-- 表單區：網站輸入與按鈕分兩行，外層區塊含背景與邊距 -->
                <div class="text-entry-block">
                  <div nz-row [nzGutter]="16" class="form-row">
                    <div nz-col [nzSpan]="12">
                      <label class="form-label required">{{ 'robot-service.config.websites.url-label' | i18n }}</label>
                      <input
                        nz-input
                        [placeholder]="
                          websites.length >= 1
                            ? ('robot-service.config.websites.remove-first' | i18n)
                            : ('robot-service.config.websites.url-placeholder' | i18n)
                        "
                        [(ngModel)]="newWebsiteUrl"
                        [disabled]="uploadDisabled || websites.length >= 1"
                        testId="robot-config-website-url-input"
                      />
                    </div>
                    <div nz-col [nzSpan]="12">
                      <label class="form-label">{{ 'robot-service.config.remark.label' | i18n }}</label>
                      <input
                        nz-input
                        [placeholder]="
                          websites.length >= 1
                            ? ('robot-service.config.websites.remove-first' | i18n)
                            : ('robot-service.config.remark.placeholder' | i18n)
                        "
                        [(ngModel)]="newWebsiteRemark"
                        [disabled]="uploadDisabled || websites.length >= 1"
                        testId="robot-config-website-remark-input"
                      />
                    </div>
                  </div>
                  <div nz-row [nzGutter]="16" class="form-row">
                    <div nz-col [nzSpan]="18">
                      <div class="meta-tips">
                        <p class="desc">{{ 'robot-service.config.websites.limit-hint' | i18n }}</p>
                        <p class="warning" *ngIf="websites.length >= 1">{{ 'robot-service.config.websites.limit-warning' | i18n }}</p>
                      </div>
                    </div>
                    <div nz-col [nzSpan]="6" class="actions" style="text-align: right">
                      <button
                        nz-button
                        nzType="primary"
                        (click)="validateWebsite()"
                        [disabled]="uploadDisabled || websites.length >= 1 || !newWebsiteUrl || websiteSetSubmitting"
                        [nzLoading]="websiteSetSubmitting"
                        testId="robot-config-website-validate-button"
                      >
                        {{ 'robot-service.config.websites.validate-and-add' | i18n }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="count-title">{{ 'robot-service.config.websites.added-title' | i18n }} ({{ websites.length }}/1)</div>
                <!-- 已添加網址列表 -->
                <div class="asset-list" *ngIf="websites.length > 0" testId="robot-config-website-list">
                  <div class="asset-item" *ngFor="let w of websites; let i = index" [testId]="'robot-config-website-item-' + i">
                    <div class="asset-icon"></div>
                    <div class="asset-main">
                      <div class="asset-title">{{ w.url }}</div>
                      <div class="asset-sub">{{ w.remark || '—' }}</div>
                      <div class="asset-status" *ngIf="w.statusText">
                        <nz-tag [nzColor]="getWebsiteStatusColor(w.taskStatus)">{{ w.statusText | i18n }}</nz-tag>
                        <span class="asset-status-sub" *ngIf="w.subStatusText">{{ w.subStatusText | i18n }}</span>
                      </div>
                      <nz-progress
                        class="asset-progress"
                        *ngIf="shouldShowWebsiteItemProgress(w)"
                        [nzPercent]="getWebsiteItemProgressPercent(w)"
                        [nzShowInfo]="shouldShowWebsiteItemPercent(w)"
                        [nzStatus]="getAssetItemProgressStatus(w.taskStatus)"
                        [testId]="'robot-config-website-progress-' + i"
                      />
                    </div>
                    <button
                      *ngIf="w.taskStatus !== 'failed'"
                      nz-button
                      nzType="link"
                      class="delete-btn"
                      (click)="deleteWebsite(w.url, i)"
                      [disabled]="uploadDisabled || assetDeleteLoading"
                      [attr.aria-label]="'common.delete' | i18n"
                      [testId]="'robot-config-website-delete-button-' + i"
                    >
                      <i nz-icon nzType="delete"></i>
                    </button>
                    <span
                      *ngIf="w.taskStatus === 'failed'"
                      class="error-hint"
                      style="color: #ff4d4f; font-size: 12px"
                      [testId]="'robot-config-website-error-hint-' + i"
                    >
                      {{ 'robot-service.config.websites.error-refresh-hint' | i18n }}
                    </span>
                  </div>
                </div>
              </div>
            </nz-tab>
            <!-- 網站連結校驗與預覽彈窗 -->
            <nz-modal
              [(nzVisible)]="websiteValidationVisible"
              [nzTitle]="websiteValidationTitleTpl"
              (nzOnCancel)="closeWebsiteValidation()"
              [nzFooter]="websiteValidationFooterTpl"
              [nzClassName]="'website-validation-modal'"
              [nzBodyStyle]="{ minHeight: '360px' }"
              [nzWidth]="820"
              testId="robot-config-website-validation-modal"
            >
              <ng-template #websiteValidationTitleTpl>
                <span>{{ 'robot-service.config.websites.modal.title' | i18n }}</span>
              </ng-template>

              <ng-container *nzModalContent>
                <div class="website-validation-body">
                  <!-- 加載中視圖（圖一） -->
                  <ng-container *ngIf="websiteValidationLoading; else validationResultTpl">
                    <div
                      class="loading-view"
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        gap: 12px;
                        text-align: center;
                      "
                    >
                      <div class="loading-icon" style="margin-bottom: 4px">
                        <i nz-icon nzType="loading" nzSpin style="font-size: 64px; color: #1677ff"></i>
                      </div>
                      <div class="loading-title" style="font-size: 12px; color: rgba(0, 0, 0, 0.65)">{{
                        'robot-service.config.websites.modal.loading' | i18n
                      }}</div>
                    </div>
                  </ng-container>

                  <!-- 校驗結果視圖（圖二／圖三） -->
                  <ng-template #validationResultTpl>
                    <!-- 失敗（圖二） -->
                    <div
                      class="result-view error-view"
                      *ngIf="websiteValidationError; else successView"
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        gap: 12px;
                        text-align: center;
                      "
                    >
                      <div class="result-icon" style="margin-bottom: 4px">
                        <i nz-icon nzType="close-circle" style="font-size: 72px; color: #ff4d4f"></i>
                      </div>
                      <div class="result-title">{{ 'robot-service.config.websites.modal.failed' | i18n }}</div>
                      <div class="error-alert" style="font-size: 12px; color: #ff4d4f">{{
                        'robot-service.config.websites.modal.unreachable' | i18n
                      }}</div>
                    </div>

                    <!-- 成功（圖三） -->
                    <ng-template #successView>
                      <div
                        class="result-view success-view"
                        style="
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                          justify-content: center;
                          gap: 12px;
                          text-align: center;
                        "
                      >
                        <div class="result-icon" style="margin-bottom: 4px">
                          <i nz-icon nzType="check-circle" style="font-size: 72px; color: #52c41a"></i>
                        </div>
                        <div class="result-title">{{ 'robot-service.config.websites.modal.success' | i18n }}</div>
                        <div class="preview-container">
                          <!-- 優先顯示可用的 iframe 預覽 -->
                          <ng-container *ngIf="websitePreviewAvailable && websitePreviewUrl as _url; else imgOrSkeleton">
                            <iframe
                              [src]="_url"
                              class="website-preview-iframe"
                              referrerpolicy="no-referrer"
                              (load)="onWebsitePreviewLoad()"
                            ></iframe>
                          </ng-container>
                          <!-- 回退：顯示抓取到的 OG 圖片；若無則顯示骨架 -->
                          <ng-template #imgOrSkeleton>
                            <ng-container *ngIf="websiteOgImageUrl as og; else previewSkeleton">
                              <img [src]="og" class="website-og-img" [attr.alt]="'robot-service.config.websites.preview-alt' | i18n" />
                            </ng-container>
                            <ng-template #previewSkeleton>
                              <div class="preview-skeleton"></div>
                            </ng-template>
                          </ng-template>
                          <div class="preview-hint">{{ 'robot-service.config.websites.modal.preview-hint' | i18n }}</div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-template>
                </div>
              </ng-container>

              <ng-template #websiteValidationFooterTpl>
                <div class="validation-footer">
                  <button
                    nz-button
                    nzType="default"
                    (click)="closeWebsiteValidation()"
                    testId="robot-config-website-validation-close-button"
                    >{{ 'common.close' | i18n }}</button
                  >
                  <button
                    nz-button
                    nzType="primary"
                    (click)="confirmAddWebsite()"
                    [disabled]="websiteValidationLoading || !!websiteValidationError || websiteSetSubmitting"
                    testId="robot-config-website-confirm-add-button"
                  >
                    {{
                      websiteValidationLoading
                        ? ('robot-service.config.websites.modal.loading' | i18n)
                        : ('robot-service.config.websites.modal.confirm-add' | i18n)
                    }}
                  </button>
                </div>
              </ng-template>
            </nz-modal>
            <nz-tab [nzTitle]="youtubeTabTitle" testId="robot-config-youtube-tab">
              <div class="assets-editor" testId="robot-config-youtube-pane">
                <!-- 表單區：YouTube 輸入與按鈕分兩行，外層區塊含背景與邊距 -->
                <div class="text-entry-block">
                  <div nz-row [nzGutter]="16" class="form-row">
                    <div nz-col [nzSpan]="12">
                      <label class="form-label required">{{ 'robot-service.config.youtube.url-label' | i18n }}</label>
                      <input
                        nz-input
                        name="newYoutubeLink"
                        [placeholder]="
                          youtubeContents.length >= 1
                            ? ('robot-service.config.youtube.remove-first' | i18n)
                            : ('robot-service.config.youtube.url-placeholder' | i18n)
                        "
                        [(ngModel)]="newYoutubeLink"
                        [disabled]="uploadDisabled || youtubeContents.length >= 1"
                        testId="robot-config-youtube-url-input"
                      />
                    </div>
                    <div nz-col [nzSpan]="12">
                      <label class="form-label">{{ 'robot-service.config.remark.label' | i18n }}</label>
                      <input
                        nz-input
                        name="newYoutubeRemark"
                        [placeholder]="
                          youtubeContents.length >= 1
                            ? ('robot-service.config.youtube.remove-first' | i18n)
                            : ('robot-service.config.remark.placeholder' | i18n)
                        "
                        [(ngModel)]="newYoutubeRemark"
                        [disabled]="uploadDisabled || youtubeContents.length >= 1"
                        testId="robot-config-youtube-remark-input"
                      />
                    </div>
                  </div>
                  <div nz-row [nzGutter]="16" class="form-row">
                    <div nz-col [nzSpan]="18">
                      <div class="meta-tips">
                        <p class="desc">{{ 'robot-service.config.youtube.limit-hint' | i18n }}</p>
                        <p class="warning" *ngIf="youtubeContents.length >= 1">{{ 'robot-service.config.youtube.limit-warning' | i18n }}</p>
                      </div>
                    </div>
                    <div nz-col [nzSpan]="6" class="actions" style="text-align: right">
                      <button
                        nz-button
                        nzType="primary"
                        (click)="validateYoutube()"
                        [disabled]="uploadDisabled || youtubeContents.length >= 1 || !newYoutubeLink"
                        testId="robot-config-youtube-validate-button"
                      >
                        {{ 'robot-service.config.youtube.validate-and-add' | i18n }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="count-title">{{ 'robot-service.config.youtube.added-title' | i18n }} ({{ youtubeContents.length }}/1)</div>
                <!-- 已添加 YouTube 連結列表 -->
                <div class="asset-list" *ngIf="youtubeContents.length > 0" testId="robot-config-youtube-list">
                  <div class="asset-item" *ngFor="let y of youtubeContents; let i = index" [testId]="'robot-config-youtube-item-' + i">
                    <ng-container *ngIf="y.thumbnailUrl; else youtubeIconTpl">
                      <div class="asset-thumb">
                        <img [src]="y.thumbnailUrl" [attr.alt]="'robot-service.config.youtube.thumbnail-alt' | i18n" />
                      </div>
                    </ng-container>
                    <ng-template #youtubeIconTpl>
                      <div class="asset-icon youtube"></div>
                    </ng-template>
                    <div class="asset-main">
                      <div class="asset-title">{{ y.youtubeLink }}</div>
                      <div class="asset-sub">{{ y.remark || '—' }}</div>
                      <div class="asset-status" *ngIf="y.taskStatus">
                        <nz-tag [nzColor]="getWebsiteStatusColor(y.taskStatus)">{{ getAttachmentTaskStatusText(y.taskStatus) }}</nz-tag>
                      </div>
                      <nz-progress
                        class="asset-progress"
                        *ngIf="shouldShowYoutubeItemProgress(y)"
                        [nzPercent]="getYoutubeItemProgressPercent(y)"
                        [nzShowInfo]="shouldShowYoutubeItemPercent(y)"
                        [nzStatus]="getYoutubeItemProgressStatus(y)"
                        [testId]="'robot-config-youtube-progress-' + i"
                      />
                    </div>
                    <button
                      nz-button
                      nzType="link"
                      class="delete-btn"
                      (click)="deleteYoutubeLink(y.youtubeLink, i)"
                      [disabled]="uploadDisabled || assetDeleteLoading"
                      [attr.aria-label]="'common.delete' | i18n"
                      [testId]="'robot-config-youtube-delete-button-' + i"
                    >
                      <i nz-icon nzType="delete"></i>
                    </button>
                  </div>
                </div>
              </div>
            </nz-tab>
            <!-- YouTube 連結校驗與預覽彈窗 -->
            <nz-modal
              [(nzVisible)]="youtubeValidationVisible"
              [nzTitle]="youtubeValidationTitleTpl"
              (nzOnCancel)="closeYoutubeValidation()"
              [nzFooter]="youtubeValidationFooterTpl"
              [nzClassName]="'youtube-validation-modal'"
              [nzBodyStyle]="{ maxHeight: '72vh', overflow: 'auto', minHeight: '320px' }"
              [nzWidth]="760"
              testId="robot-config-youtube-validation-modal"
            >
              <ng-template #youtubeValidationTitleTpl>
                <span>{{ 'robot-service.config.youtube.modal.title' | i18n }}</span>
              </ng-template>

              <ng-container *nzModalContent>
                <div class="youtube-validation-body">
                  <!-- 加載中視圖（圖一） -->
                  <ng-container *ngIf="youtubeValidationLoading; else youtubeValidationResultTpl">
                    <div
                      class="loading-view"
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        gap: 12px;
                        text-align: center;
                      "
                    >
                      <div class="loading-icon" style="margin-bottom: 4px">
                        <i nz-icon nzType="loading" nzSpin style="font-size: 64px; color: #1677ff"></i>
                      </div>
                      <div class="loading-title" style="font-size: 12px; color: rgba(0, 0, 0, 0.65)">{{
                        'robot-service.config.youtube.modal.loading' | i18n
                      }}</div>
                    </div>
                  </ng-container>

                  <!-- 校驗結果視圖（圖二／圖三） -->
                  <ng-template #youtubeValidationResultTpl>
                    <!-- 失敗（圖二） -->
                    <div
                      class="result-view error-view"
                      *ngIf="youtubeValidationError; else youtubeValidationSuccessView"
                      style="
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        gap: 12px;
                        text-align: center;
                      "
                    >
                      <div class="result-icon" style="margin-bottom: 4px">
                        <i nz-icon nzType="close-circle" style="font-size: 72px; color: #ff4d4f"></i>
                      </div>
                      <div class="result-title">{{ 'robot-service.config.youtube.modal.failed' | i18n }}</div>
                      <div class="error-alert" style="font-size: 12px; color: #ff4d4f">{{ youtubeValidationError }}</div>
                    </div>

                    <!-- 成功（圖三） -->
                    <ng-template #youtubeValidationSuccessView>
                      <div
                        class="result-view success-view"
                        style="
                          display: flex;
                          flex-direction: column;
                          align-items: center;
                          justify-content: center;
                          gap: 12px;
                          text-align: center;
                        "
                      >
                        <div class="result-icon" style="margin-bottom: 4px">
                          <i nz-icon nzType="check-circle" style="font-size: 72px; color: #52c41a"></i>
                        </div>
                        <div class="result-title">{{ 'robot-service.config.youtube.modal.success' | i18n }}</div>
                        <div class="preview-container">
                          <ng-container *ngIf="youtubeThumbnailUrl; else previewSkeleton">
                            <img
                              [src]="youtubeThumbnailUrl"
                              class="youtube-preview-img"
                              [attr.alt]="'robot-service.config.youtube.thumbnail-alt' | i18n"
                            />
                          </ng-container>
                          <ng-template #previewSkeleton>
                            <div class="preview-skeleton"></div>
                          </ng-template>
                          <div class="preview-hint">{{ 'robot-service.config.youtube.modal.preview-hint' | i18n }}</div>
                        </div>
                      </div>
                    </ng-template>
                  </ng-template>
                </div>
              </ng-container>

              <ng-template #youtubeValidationFooterTpl>
                <div class="validation-footer">
                  <button
                    nz-button
                    nzType="default"
                    (click)="closeYoutubeValidation()"
                    testId="robot-config-youtube-validation-close-button"
                    >{{ 'common.close' | i18n }}</button
                  >
                  <button
                    nz-button
                    nzType="primary"
                    (click)="confirmAddYoutube()"
                    [disabled]="youtubeValidationLoading || !!youtubeValidationError"
                    testId="robot-config-youtube-confirm-add-button"
                  >
                    {{ 'robot-service.config.youtube.modal.confirm-add' | i18n }}
                  </button>
                </div>
              </ng-template>
            </nz-modal>
            <nz-tab [nzTitle]="textsTabTitle" testId="robot-config-texts-tab">
              <div class="assets-editor text-tab-pane" testId="robot-config-texts-pane">
                <!-- 表單區：文本與按鈕同一行，按鈕垂直居中，外層區塊含背景與邊距 -->
                <div class="text-entry-block">
                  <div nz-row [nzGutter]="8" class="form-row">
                    <div nz-col [nzSpan]="20">
                      <label class="form-label required">{{ 'robot-service.config.texts.label' | i18n }}</label>
                      <textarea
                        nz-input
                        rows="4"
                        [placeholder]="'robot-service.config.texts.placeholder' | i18n"
                        [(ngModel)]="newPlainTextContent"
                        [disabled]="uploadDisabled"
                        testId="robot-config-plain-text-textarea"
                      ></textarea>
                    </div>
                    <div nz-col [nzSpan]="4" class="actions" style="text-align: right">
                      <button
                        nz-button
                        nzType="primary"
                        (click)="savePlainTextContent()"
                        [disabled]="uploadDisabled || !newPlainTextContent"
                        testId="robot-config-plain-text-add-button"
                      >
                        {{ 'robot-service.config.texts.add' | i18n }}
                      </button>
                    </div>
                  </div>
                  <!-- 限制與提示 -->
                  <div class="meta-tips">
                    <p class="desc">{{ 'robot-service.config.texts.limit-hint' | i18n }}</p>
                  </div>
                </div>

                <div class="count-title">{{ 'robot-service.config.texts.added-title' | i18n }}</div>
                <div class="asset-list text-list" *ngIf="plainTextContents.length > 0" testId="robot-config-plain-text-list">
                  <div class="asset-item" *ngFor="let t of plainTextContents; let i = index" [testId]="'robot-config-plain-text-item-' + i">
                    <div class="asset-icon text"></div>
                    <div class="asset-main">
                      <div class="asset-title">{{ t.plainText }}</div>
                      <div class="asset-status" *ngIf="t.taskStatus">
                        <nz-tag [nzColor]="getWebsiteStatusColor(t.taskStatus)">{{ getAttachmentTaskStatusText(t.taskStatus) }}</nz-tag>
                      </div>
                      <nz-progress
                        class="asset-progress"
                        *ngIf="shouldShowPlainTextItemProgress(t)"
                        [nzPercent]="getPlainTextItemProgressPercent(t)"
                        [nzShowInfo]="shouldShowPlainTextItemPercent(t)"
                        [nzStatus]="getPlainTextItemProgressStatus(t)"
                        [testId]="'robot-config-plain-text-progress-' + i"
                      />
                    </div>
                    <button
                      nz-button
                      nzType="link"
                      class="delete-btn"
                      (click)="deletePlainTextContent(t.plainText, i)"
                      [disabled]="uploadDisabled || assetDeleteLoading"
                      [attr.aria-label]="'common.delete' | i18n"
                      [testId]="'robot-config-plain-text-delete-button-' + i"
                    >
                      <i nz-icon nzType="delete"></i>
                    </button>
                  </div>
                </div>
              </div>
            </nz-tab>
          </nz-tabset>
        </div>
      </div>
    </div>
  </div>
</nz-spin>
